import React from 'react';
import cx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { InfoRounded } from '@material-ui/icons';

interface IntegrationInfoIconProps {
  className?: string;
}

const IntegrationInfoIcon = (props: IntegrationInfoIconProps) => {
  const classes = useStyles();
  return <InfoRounded className={cx(classes.root, props.className)} />;
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fill: theme.palette.info.main,
    fontSize: theme.typography.pxToRem(24),
    lineHeight: 0
  }
}));

export default IntegrationInfoIcon;
